import React from "react";
import { Col, Row, Button } from "reactstrap";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import TableHelper from "../components/tableHelper";
import { useTranslation } from "react-i18next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const DeliveryConfirmationBreakdownTable = ({
  tableData,
  error,
  loading,
}) => {

  const { ExportCSVButton } = CSVExport;
  const { t } = useTranslation();

  const statusFormatter = cell => {
    return (
      <>
        {cell? (
          <Button className="btn-status" disabled color="primary">
            {t("deliveryConfirmation.breakdownView.label.statusDelivered")}
          </Button>
        ) : (
          <Button className="btn-status" disabled color="danger">
            {t("deliveryConfirmation.breakdownView.label.statusUndelivered")}
          </Button>
        )}
      </>
    );
  };

  const statusCsvFormatter = cell => {
    let status = t("deliveryConfirmation.breakdownView.label.statusUndelivered");
    if (cell) {
      status = t("deliveryConfirmation.breakdownView.label.statusDelivered");
    }
    return status;
  };

  const storeFormatter = cell => {
    return (
      <b>{cell}</b>
    );
  };

  const noteFormatter = (row, cell) => {
    let textColorClassName = "";
    if (row.store.includes("Apple Music") || row.store.includes("iTunes")) {
      textColorClassName = "text-danger";
    }
    else if(row.store === "United Media Agency" || row.store === "Yandex Music") {
      textColorClassName = "text-warning";
    }
    return (
      <p className={textColorClassName}>{cell}</p>
    );
  };

  const columns = [
    {
      dataField: "store",
      text: t("deliveryConfirmation.breakdownView.column.store"),
      formatter: storeFormatter,
      sort: false,
      csvExport: true,
      headerStyle: (colum, colIndex) => {
        return { width: "50px" };
      }
    },
    {
      dataField: "additionalNote",
      text: t("deliveryConfirmation.breakdownView.column.additionalNote"),
      formatter: noteFormatter,
      sort: false,
      csvExport: true,
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      }
    },
    {
      dataField: "status",
      text: t("deliveryConfirmation.breakdownView.column.status"),
      formatter: statusFormatter,
      csvFormatter: statusCsvFormatter,
      sort: false,
      csvExport: true,
      headerStyle: (colum, colIndex) => {
        return { width: "50px" };
      }
    },
  ];

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) : (
        <ToolkitProvider
          keyField="store"
          data={tableData}
          columns={columns}
          exportCSV={{
            fileName: 'dsp-delivery-details.csv',
          }}
        >
          {props => (
            <div>
              <Row>
                <Col>
                  <div className="m-5 m-5">
                  </div>
                </Col>
                <Col>
                  <div className="flexEndContainer">

                    <ExportCSVButton
                      className="btn btn-outline-info"
                      {...props.csvProps}
                    >
                      {t("deliveryConfirmation.breakdownView.button.exportCSV")}
                    </ExportCSVButton>
                  </div>
                </Col>
              </Row>

              <BootstrapTable
               {...props.baseProps}
                bordered={ false }
              />
            </div>
          )}
        </ToolkitProvider>
      )}
    </>
  );
};

export default DeliveryConfirmationBreakdownTable;